import React from 'react';
import { Controller } from 'react-hook-form';
import cn from 'classnames';

import HintQuestion from 'shared/ui/Hint/HintQuestion';

import styles from './RadioGroup.module.scss';

interface CustomRadioOption {
    value: string;
    label: string;
    hint?: string;
}

interface IRadioGroupProps {
    name: string;
    options: CustomRadioOption[];
    required?: boolean;
    className?: string;
    control: any;
}

const RadioGroup: React.FC<IRadioGroupProps> = ({
    name,
    options,
    required = false,
    className,
    control,
}) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={{ required }}
            render={({ field: { onChange, value, name } }) => (
                <div className={cn(styles.radioGroup, className)}>
                    {options.map((option) => (
                        <label key={option.value} className={styles.radioOption}>
                            <input
                                type="radio"
                                name={name}
                                value={option.value}
                                checked={value === option.value}
                                onChange={() => onChange(option.value)}
                                className={cn(
                                    styles.radioInput,
                                    styles.colorRadioInput,
                                )}
                            />
                            <span className={styles.radioCustom} />
                            <span className={styles.radioLabel}>
                                {option.label}
                                {option.hint && value === option.value && (
                                    <HintQuestion placement="right">
                                        {option.hint}
                                    </HintQuestion>
                                )}
                            </span>
                        </label>
                    ))}
                </div>
            )}
        />
    );
};

export default RadioGroup;